// extracted by mini-css-extract-plugin
export default {"container":"style_container__A6bJK","content":"style_content__vfJ0I","title":"style_title__Ahp70","title_header":"style_title_header__tSq8u","title_inner":"style_title_inner__0ml4F"};